import { useTranslation } from 'next-i18next';
import Swiper from '~/ui/components/common/Swiper/Swiper';
import { SwiperImages } from '~/ui/assets/mocks/swiperImages';

interface IBeddingItem {
  id: string;
  tagline: string;
  title: string;
  description: string;
  link: string;
  image: string;
}

const BeddingSection = () => {
  const { t: tBedding } = useTranslation('', { keyPrefix: '$pages.$home.$beddingSection' });
  const { t: tLink } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$bedding' });

  const beddingItems: IBeddingItem[] = [
    {
      id: 'bedding-sets',
      tagline: tBedding('beddingSetsTagline'),
      title: tBedding('beddingSetsTitle'),
      description: tBedding('beddingSetsDescription'),
      link: tLink('beddingSets'),
      image: '/images/homePage/beddingSection/bedding-sets',
    },
    {
      id: 'linens',
      tagline: tBedding('linensTagline'),
      title: tBedding('linensTitle'),
      description: tBedding('linensDescription'),
      link: tLink('linens'),
      image: '/images/homePage/beddingSection/linens',
    },
    {
      id: 'blankets-duvets',
      tagline: tBedding('blanketsDuvetsTagline'),
      title: tBedding('blanketsDuvetsTitle'),
      description: tBedding('blanketsDuvetsDescription'),
      link: tLink('blanketsDuvets'),
      image: '/images/homePage/beddingSection/blankets-duvets',
    },
    {
      id: 'pillows',
      tagline: tBedding('pillowsTagline'),
      title: tBedding('pillowsTitle'),
      description: tBedding('pillowsDescription'),
      link: tLink('pillows'),
      image: '/images/homePage/beddingSection/pillows',
    },
  ];

  const swiperSlides: SwiperImages[] = beddingItems.map(item => ({
    id: item.id,
    tagline: item.tagline,
    description: item.description,
    url_key: item.link,
    img: item.image,
    alt: item.title,
    title: item.title,
  }));

  return (
    <section className="base-section bedding-section hp-section">
      <div className="content-section">
        <h2>{tBedding('title')}</h2>
      </div>
      <Swiper slides={swiperSlides} />
    </section>
  );
};

export default BeddingSection;
